import { render, staticRenderFns } from "./index.vue?vue&type=template&id=298fdffe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=298fdffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fdffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298fdffe')) {
      api.createRecord('298fdffe', component.options)
    } else {
      api.reload('298fdffe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=298fdffe&scoped=true&", function () {
      api.rerender('298fdffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoData/index.vue"
export default component.exports